// extracted by mini-css-extract-plugin
export default {"organization-desc-wrapper":"organization-desc-wrapper_naICX"};